import { css } from '@emotion/react';
import React from 'react';
import { LAYOUT2, TYPOGRAPHY2 } from '../Styles';

type StrongLabeledCardProps = {
  title: string | React.ReactNode;
  children: React.ReactNode;
  titleRight?: React.ReactNode;
  height?: string | number;
};

const CARD_STYLE = css`
  label: CARD_STYLE;
  background: var(--background);
  display: 'flex';
  flex-direction: 'column' as const;
  min-height: 0;
`;

const TITLE_CONTAINER_STYLE = css`
  label: TITLE_CONTAINER_STYLE;
  padding: 0 ${LAYOUT2.spacing2}px;
  border-bottom: 1px solid var(--border2);
  display: flex;
  height: ${LAYOUT2.spacing5}px;
  justify-content: space-between;
  align-items: center;
`;

const CARD_TITLE_STYLE = css`
  label: CARD_TITLE_STYLE;
  ${TYPOGRAPHY2.xSmallBold}
  color: var(--text2);
  text-transform: uppercase;
  flex-grow: 1;
`;

const CONTENT_STYLE = css`
  label: CONTENT_STYLE;
  padding: ${LAYOUT2.spacing2}px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

/**
 * just for the record, this is a terrible name, so consider it a placeholder
 * @param param0
 * @returns
 */
export const StrongLabeledCard = ({ title, children, titleRight, height }: StrongLabeledCardProps) => (
  <div css={[CARD_STYLE, css`height: ${height}`]}>
    <div css={TITLE_CONTAINER_STYLE}>
      <div css={CARD_TITLE_STYLE}>{title}</div>
      {titleRight}
    </div>
    <div css={CONTENT_STYLE}>{children}</div>
  </div>
);
